import { FilterKey } from '@studyportals/search-filters';
export class SearchVolumeCountriesAttendanceRule {
    filterKey = FilterKey.COUNTRY;
    countryIdsWithSearchVolume = [
        108, 30, 202, 56, 106, 24, 10, 14, 15, 69, 71, 76, 82, 151, 105, 161, 167, 112, 113, 170, 129, 131, 132, 191, 9, 11, 20, 22, 27, 28,
        121, 185, 117, 197, 212
    ];
    getName() {
        return 'SearchVolumeCountriesAttendanceRule';
    }
    forSearch(dependencies) {
        const { seoInfoBase, filterState } = dependencies;
        const value = seoInfoBase.getFilterOptionValueBy(this.filterKey, filterState);
        if (!value) {
            return Promise.resolve(false);
        }
        return Promise.resolve(this.hasSearchVolume(value));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    forSitemapGenerator(filterKeyValues) {
        throw new Error('Method not implemented.');
    }
    hasSearchVolume(value) {
        return this.countryIdsWithSearchVolume.includes(parseInt(value));
    }
}
